import { createFileRoute } from '@tanstack/react-router'

import { DigitalProductInvitesAssign } from '@/features/invites/Assign'

export const Route = createFileRoute('/_event/convites/$code')({
  staticData: {
    isPublic: true
  },
  component: DigitalProductInvitesAssignPage
})

function DigitalProductInvitesAssignPage() {
  const { code } = Route.useParams()

  return <DigitalProductInvitesAssign id={code} />
}
